interface IProps {
  hasjivochat: boolean;
  jivochat: string | number;
}

export const register = (props: IProps) => {
  if (!props.hasjivochat) {
    return;
  }

  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  script.src = '//code.jivosite.com/script/widget/' + props.jivochat;
  return script;
};

export const unregister = (props: IProps) => {
  if (!props.hasjivochat) {
    return;
  }

  const elem = document.getElementById('jivo-iframe-container');
  elem?.parentNode.removeChild(elem);
  Object.keys(window)
    .filter(key => key.includes('jivo'))
    .forEach(key => delete (window as any)[key]);
  const jivo = document.querySelectorAll('jdiv');
  jivo.forEach(value => value.remove());
};
